"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelStateFromResponse = void 0;
var getModelState_1 = require("./getModelState");
/**
 * Gets an instance of IModelState and adds any matching server side errors to the vee-validate form
 * See https://vee-validate.logaretm.com/v4/guide/components/handling-forms#setting-errors-manually
 * @param {T} response server side response with validation errors
 * @param formActions vee-validate FormActions
 * @template TResponse response type - must be an IValidationResponse
 * @returns an instance of IModelState
 */
function getModelStateFromResponse(response, formActions) {
    if (!response.errors) {
        return { modelErrors: [], propertyErrors: {} };
    }
    return (0, getModelState_1.getModelState)(response.errors, formActions);
}
exports.getModelStateFromResponse = getModelStateFromResponse;
//# sourceMappingURL=getModelStateFromResponse.js.map